import Ring from './Ring';
import MapOne from 'componentsFor3D/MapOne';
import Earth from 'componentsFor3D/Earth';
import Sun from 'componentsFor3D/Sun';
import Mark from 'componentsFor3D/Mark';
import { Cloud, Detailed, Sparkles } from '@react-three/drei';
import Area1ForPart1 from 'componentsFor3D/Area1ForPart1';
import PointerGroup from './PointerGroup';
import MapPin from 'componentsFor3D/MapPin';
import SvgImporter from './SvgImporter';
import { useContext, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ControlContext } from 'provider/ControlProvider';

const Part1 = () => {
  const midBar = useRef<any>(null);
  const semiBar = useRef<any>(null);
  const largeBar = useRef<any>(null);
  const { content, prepare } = useContext(ControlContext);

  // useEffect(() => {
  //   if (midBar.current?.rotation) {
  //     gsap.fromTo(
  //       midBar.current.rotation,
  //       { y: 0 },
  //       {
  //         duration: 20,
  //         ease: 'none',
  //         repeat: -1,
  //         y: Math.PI * 2,
  //       }
  //     );
  //   }
  //   if (semiBar.current?.rotation) {
  //     gsap.fromTo(
  //       semiBar.current.rotation,
  //       { y: Math.PI * 2 },
  //       {
  //         duration: 5,
  //         ease: 'none',
  //         repeat: -1,
  //         y: 0,
  //       }
  //     );
  //   }
  //   if (largeBar.current?.rotation) {
  //     gsap.to(largeBar.current.rotation, {
  //       duration: 3,
  //       ease: 'power2.out',
  //       repeat: -1,
  //       y: 3,
  //       yoyo: true,
  //     });
  //   }
  // }, []);

  return (
    <group position={[-1.38, 0, 0.16]} visible={prepare && content.type === 0}>
      <Ring innerRadius={0.86} outerRadius={1.06} key={'Ring'} />
      <Detailed distances={[0, 2, 10]}>
        <group name='detailMap1'>
          <Cloud
            position={[0.4, 0.2, 0.03]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={1}
            width={3}
            opacity={0.8}
          />
          <Cloud
            position={[0.4, 0.2, 0.5]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={3}
            width={4}
            opacity={0.8}
          />
          <Cloud
            position={[0.3, 0.2, 0.5]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={1}
            width={5}
            opacity={0.8}
          />
          <Cloud
            position={[0, 0.1, 0.1]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={1}
            width={5}
            opacity={0.8}
          />
          <Cloud
            position={[0.2, 0.2, 0.3]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={1}
            width={5}
            opacity={0.8}
          />
          <Cloud
            position={[0.3, 0.2, 0.3]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={4}
            width={5}
            opacity={0.8}
          />
          <Cloud
            position={[0.5, 0.13, 0.3]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={1}
            width={5}
            opacity={0.8}
          />
          <Cloud
            position={[-0.3, 0.13, 0.3]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={1}
            width={5}
            opacity={0.8}
          />
          <Cloud
            position={[-0.2, 0.13, 0.3]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={2}
            width={5}
            opacity={0.8}
          />
          <Cloud
            position={[-0.1, 0.13, 0.5]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={2}
            width={5}
            opacity={0.8}
          />
          <Cloud
            position={[-0.1, 0.13, 0.4]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={2}
            width={5}
            opacity={0.8}
          />
          <Cloud
            position={[-0.06, 0.13, 0.4]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={2}
            width={5}
            opacity={0.8}
          />
          <Cloud
            position={[-0.0, 0.25, 0.6]}
            scale={[0.007, 0.007, 0.007]}
            speed={0}
            depth={2}
            width={5}
            opacity={0.8}
          />
          <PointerGroup />
          {/* <Sparkles
            position={[0, 0.3, 0]}
            scale={1.2}
            size={0.7}
            speed={0}
            color={'#D4DCFF'}
          /> */}
          <Mark pos={[-0.2, 0, 0.3]} />
          <Mark pos={[0.2, 0, 0.6]} />
          <Mark pos={[-0.3, 0, 0.64]} />
          <MapPin index={1} pos={[0.64, 0.08, 0.28]} />
          <MapPin index={2} pos={[0.4, 0.15, 0.23]} />
        </group>
        <group></group>
      </Detailed>
      <Detailed distances={[0, 1, 1.7, 10]}>
        <group></group>
        <group></group>
        <group></group>
      </Detailed>
      <SvgImporter
        pos={[-1.054, 0.042, 1.05]}
        url='/assets/part1_clock_line.svg'
        name='clock_line'
      />

      <SvgImporter
        pos={[-0.915, 0.042, 0.913]}
        url='/assets/part1_clock_largeBar.svg'
        name='largeBar'
        refVal={largeBar}
      />
      <SvgImporter
        pos={[-0.888, 0.046, 0.884]}
        url='/assets/part1_clock_semiBar.svg'
        name='semiBar'
        refVal={semiBar}
      />
      <SvgImporter
        pos={[-0.886, 0.042, 0.881]}
        url='/assets/part1_clock_midBar.svg'
        name='midBar'
        refVal={midBar}
      />
      <SvgImporter
        pos={[-1.052, 0.042, 1.047]}
        url='/assets/part1_clock_text.svg'
        name='clock_text'
        segment={10}
      />
      <SvgImporter
        pos={[-0.957, 0.042, 0.953]}
        url='/assets/part1_clock_mark.svg'
        name='clock_mark'
      />

      <Area1ForPart1 />
      <MapOne />
      <Earth />
      <Sun />
    </group>
  );
};

export default Part1;
